import InputBase from '@material-ui/core/InputBase';
import { withStyles } from '@material-ui/core/styles';

const TextInput = withStyles(() => ({
  root: {
    'label + &': { marginTop: 5 },
  },
  multiline: {
    width: '100%'
  },
  input: {
    position: 'relative',
    backgroundColor: '#FFF9E3',
    fontSize: 16,
    width: '100%',
    padding: '12px 12px',
    boxShadow: '0 0 0 1px #DEDEDE',
    borderRadius: 5,

    '&:focus': { boxShadow: '0 0 0 2px #FFCE15' }
  }
}))(InputBase);

export default TextInput;
